export const ALEXANDRIA_COMPANY_PICKER_TEST_IDS = {
  alexandriaId: 'alexandria-picker__alexandria-id',
  providers: 'alexandria-picker__providers',
  providerChip: (providerCode: string) => `alexandria-picker__provider-${providerCode}`,
  providersLoading: 'alexandria-picker__providers-loading',
  noProviders: 'alexandria-picker__no-providers',
  profileUnresolved: 'alexandria-picker__profile-unresolved',
  profileUnavailable: 'alexandria-picker__profile-unavailable',
} as const;
